module.exports = __webpack_public_path__ + "img/bi.9b802cc.svg";